import { WatcherType } from "../types/watcherType";

export const watcherDepartment = (props : WatcherType ) => {
    const { watcher, fields, initialFields } = props;
        let process = [...fields]
        process = process.map((section, idx) => {
            if (!section.fields) return section;
            let sectionTemp = { ...section }
            let fields = [...section?.fields];
            const cityIdx = fields.findIndex(
                (field: any) => field.name == "city"
            );
            const neighborhoodIdx = fields.findIndex(
                (field: any) => field.name == "neighborhood"
            );
            if (cityIdx === -1) return section;
            const cityOptions = initialFields[idx].fields[cityIdx].options?.filter((option: any) => {
                return option.relationKey === watcher;
            })
            if(cityOptions){
            fields[cityIdx] = {
                ...fields[cityIdx],
                options: [{  
                    id: "undefined",
                    label: "Seleccionar ciudad",
                    value: "",
                    relationKey: "" }, ...cityOptions],
            }}
            if (neighborhoodIdx !== -1) {
                fields[neighborhoodIdx] = {
                    ...fields[neighborhoodIdx],
                    options: [{  
                        id: "undefined",
                        label: "Seleccionar barrio",
                        value: "",
                        relationKey: "" }],
                }
            }
            sectionTemp.fields = fields;
            return sectionTemp;
        });
        return process;
}
